import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  subtext?: string;
  href?: string;
}
export const SHOPIFY_URL = 'https://ybrn1w-fm.myshopify.com/cart/62590172496243:1?channel=buy_button';
export function CTAButton({
  text = '👉 SÍ, QUIERO ACCEDER AHORA',
  className = '',
  subtext,
  href = '#comprar'
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-363">
      <motion.a href={href} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} animate={{
      boxShadow: ['0px 0px 0px rgba(34, 197, 94, 0)', '0px 0px 20px rgba(34, 197, 94, 0.5)', '0px 0px 0px rgba(34, 197, 94, 0)'],
      y: [0, -3, 0]
    }} transition={{
      duration: 2.5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="w-full max-w-xl bg-green-500 hover:bg-green-600 text-white font-extrabold text-xl md:text-2xl py-5 px-8 rounded-full shadow-xl flex flex-col items-center justify-center text-center border-b-4 border-green-700" data-id="element-364">
        <span className="flex items-center gap-2" data-id="element-365">
          {text} <ArrowRight className="w-6 h-6" data-id="element-366" />
        </span>
      </motion.a>
      {subtext && <p className="mt-3 text-sm md:text-base font-semibold text-gray-700 flex items-center gap-1" data-id="element-367">
          {subtext}
        </p>}
    </div>;
}